import * as util from "./util.js";
const presets = {
  Simple: {
    points: [
      { 0: 0, 1: 0, eid: 11, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.33125000000000004, 1: 0, eid: 29, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.775, 1: 0.050000000000000044, eid: 28, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.875, 1: 0.3437500000000001, eid: 30, flag: 1, deg: 3, tangent: 1 },
      { 0: 0.9437499999999999, 1: 0.725, eid: 26, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.9980263157894737, 1: 1, eid: 14, flag: 0, deg: 3, tangent: 1 },
      { 0: 1, 1: 1, eid: 22, flag: 0, deg: 3, tangent: 1 },
    ],
    deg: 3,
    eidgen: { _cur: 31 },
  },
  //    Simple     : {"points":[{"0":0,"1":0,"eid":11,"flag":0,"deg":3,"tangent":1},{"0":0.56875,"1":0,"eid":26,"flag":0,"deg":3,"tangent":1},{"0":0.8042763157894738,"1":0,"eid":14,"flag":1,"deg":3,"tangent":1},{"0":1,"1":1,"eid":22,"flag":0,"deg":3,"tangent":1}],"deg":3,"eidgen":{"_cur":27}},
  Basic: {
    points: [
      { 0: 0, 1: 0, eid: 11, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.5480263157894739, 1: 0, eid: 14, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.7733552631578947, 1: 0, eid: 15, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.912171052631579, 1: 0.08256578947368431, eid: 13, flag: 1, deg: 3, tangent: 1 },
      { 0: 0.9625, 1: 0.2187500000000001, eid: 24, flag: 0, deg: 3, tangent: 1 },
      { 0: 1, 1: 1, eid: 22, flag: 0, deg: 3, tangent: 1 },
    ],
    deg: 3,
    eidgen: { _cur: 25 },
  },
  Clustered: {
    points: [
      { 0: 0, 1: 0, eid: 11, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.4980263157894739, 1: 0, eid: 14, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.680263157894737, 1: 0.10624999999999973, eid: 20, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.7874999999999999, 1: 0.9312500000000002, eid: 23, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.8733552631578947, 1: 0.5138157894736841, eid: 15, flag: 1, deg: 3, tangent: 1 },
      { 0: 0.9309210526315789, 1: 0.6763157894736843, eid: 13, flag: 0, deg: 3, tangent: 1 },
      { 0: 1, 1: 1, eid: 22, flag: 0, deg: 3, tangent: 1 },
    ],
    deg: 3,
    eidgen: { _cur: 24 },
  },
  Poissonish: {
    points: [
      { 0: 0, 1: 0, eid: 11, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.26249999999999996, 1: 0, eid: 30, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.26249999999999996, 1: 0, eid: 31, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.30625, 1: 0, eid: 29, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.42499999999999993, 1: 0.11249999999999993, eid: 26, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.45625000000000004, 1: 0.2500000000000001, eid: 32, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.5624999999999999, 1: 0.43125000000000024, eid: 33, flag: 1, deg: 3, tangent: 1 },
      { 0: 0.7042763157894738, 1: 0.56875, eid: 14, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.7875, 1: 1, eid: 28, flag: 0, deg: 3, tangent: 1 },
      { 0: 1, 1: 1, eid: 22, flag: 0, deg: 3, tangent: 1 },
    ],
    deg: 3,
    eidgen: { _cur: 34 },
  },
  Wavy: {
    points: [
      { 0: 0, 1: 0.4624999999999998, eid: 80, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.36875, 1: 0.43125, eid: 106, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.42499999999999993, 1: 0.41875000000000007, eid: 105, flag: 1, deg: 3, tangent: 1 },
      { 0: 0.5, 1: 0.2187499999999999, eid: 104, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.5375000000000001, 1: 0.2312500000000003, eid: 103, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.6062500000000001, 1: 0.42500000000000004, eid: 101, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.6749999999999999, 1: 0.4375000000000002, eid: 97, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.7437499999999999, 1: 0, eid: 100, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.76875, 1: 0.11250000000000004, eid: 107, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.8125000000000001, 1: 0.4500000000000002, eid: 99, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.8375, 1: 1, eid: 102, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.88125, 1: 1, eid: 98, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.9312499999999999, 1: 0, eid: 96, flag: 0, deg: 3, tangent: 1 },
    ],
    deg: 3,
    eidgen: { _cur: 108 },
  },
  Green: {
    points: [
      { 0: 0, 1: 0, eid: 11, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.14375000000000002, 1: 0.20625000000000004, eid: 27, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.38749999999999984, 1: 0.04375000000000007, eid: 26, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.4250000000000004, 1: 1, eid: 28, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.65, 1: 0.9937500000000001, eid: 29, flag: 0, deg: 3, tangent: 1 },
      { 0: 0.69375, 1: 0.6375000000000001, eid: 30, flag: 1, deg: 3, tangent: 1 },
      { 0: 1, 1: 0.55, eid: 14, flag: 0, deg: 3, tangent: 1 },
      { 0: 1, 1: 0.56875, eid: 22, flag: 0, deg: 3, tangent: 1 },
    ],
    deg: 3,
    eidgen: { _cur: 31 },
  },
};

export { presets };
